import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { createLazyOption, LazyOption } from 'owa-options-core';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    optionTitle_dynamicEmail,
    optionSearchTerms_dynamicEmail,
} from './DynamicEmailOption.locstring.json';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

const DynamicEmailOption: LazyOption = createLazyOption(
    {
        key: 'dynamicEmail',
        titleStringKey: optionTitle_dynamicEmail,
        searchTermsStringKey: optionSearchTerms_dynamicEmail,
        isHidden: () => {
            return !isFeatureEnabled('rp-amp') || !isConsumer();
        },
    },
    lazyFullModule,
    m => m.default
);
export default DynamicEmailOption;
